function noselected() {
    document.querySelector(".bundle-section-container .step-1 .step-1-container").classList.add("open");
    document.querySelector(".bundle-section").classList.add("overflow-y-unset");

}

function noselectedclose() {
    document.querySelector(".bundle-section-container .step-1 .step-1-container").classList.remove("open");
    document.querySelector(".bundle-section").classList.remove("overflow-y-unset");
}

function updatefirstgrid() {
    var items = document.querySelector(".step-1 .step-container .products-section").innerHTML;
    var requireditems = false
    document.querySelectorAll(".step-1 .step-container .products-section .product-section.save-15.additional-item").length
        ? document.querySelectorAll(".step-1 .step-container .products-section .product-section.save-15.additional-item").forEach(function (additem) {
            if (!additem.classList.contains("active")) {
                requireditems = true
            }
            else {
                if (document.querySelectorAll(".step-1 .step-container .products-section .product-section.save-15.additional-item").length == document.querySelectorAll(".step-1 .step-container .products-section .product-section.save-15.additional-item.active").length) {
                    requireditems = true;
                }
                else {
                    requireditems = false;
                }

            }
        }) : document.querySelectorAll(".save-15.active").length ? requireditems = true : requireditems = false;
    var newitem = '<div onclick="selectionprocess(event)" class="product-section no-selected save-15 additional-item pointer flex flex-column items-center p-relative open-popup" data-save="1575" data-min="2" data-id="43787509399726"><svg onclick="removeadditional(event, "Bespaar 15% op elke extra kleur");" class="icon icon-close max-20px p-absolute h-10px t-10 r-10 z-9 pointer" aria-hidden="true" focusable="false"><use href="#icon-close"></use></svg><img class="max-100 o-cover" src="//gel-nail-wrap.nl/cdn/shop/t/6/assets/add-15.png?v=101526582812641706761693122363" alt=""><p class="m-0 text-center font-12-b p-l-10 p-r-10">Bespaar 15% op elke extra kleur</p></div>';

    if (document.querySelectorAll(".save-15.additional-item").length > document.querySelectorAll(".save-15.additional-item.active").length) {
        requireditems = false
    }

    if (requireditems) {
        document.querySelector(".step-1 .step-container .products-section").innerHTML = items + newitem
    }

    document.querySelectorAll(".save-15.active+.save-15").forEach(function (sav15) {
        if (sav15.classList.contains("removeit")) {
            sav15.classList.remove("removeit")
        }
    });

    hideoptions();
}

function selectionprocess(event) {
    var selection = event.currentTarget;
    if (selection.classList.contains("no-selected")) {
        document.querySelectorAll(".product-section.open-popup").forEach(function (openpopup) {
            openpopup.classList.remove("open-popup");
        });

        if (selection.classList.contains("save-15") && selection.classList.contains("active")) {
            // console.log("1st yes")
            // if (selection.querySelector(".save-15.active svg").contains(event.target)) {
            //     console.log("2nd yes")
            //     selection.classList.remove("active");
            //     selection.querySelector("img").setAttribute("src", "//gel-nail-wrap.nl/cdn/shop/t/6/assets/add-15.png?v=101526582812641706761693122363");
            //     selection.querySelector("p").textContent = 'Bespaar 15%';
            // }   
        }
        else {
            selection.classList.add("open-popup")
            noselected();
        }

        return;
    }

    if (selection.classList.contains("selected-product")) {
        var id = selection.getAttribute("data-id");
        var title = selection.getAttribute("data-title");
        var save = selection.getAttribute("data-save");
        var img = selection.querySelector("img").getAttribute("src");
        var title = selection.querySelector("p").textContent;
        var poupdata = document.querySelector(".product-section.open-popup");
        poupdata.setAttribute("data-id", id);
        poupdata.setAttribute("data-title", title);
        poupdata.setAttribute("data-save", save);
        poupdata.querySelector("img").setAttribute("src", img);
        poupdata.querySelector("p").textContent = title;
        poupdata.classList.add("active");
        noselectedclose();
        updatefirstgrid();
        return;
    }

    var numberSelected = parseInt(selection.getAttribute("data-min"));
    if (numberSelected == 1 && !selection.classList.contains('notaddoptional')) {
        selection.parentElement.querySelector(".active") != null
            ? selection.parentElement.querySelector(".active").classList.remove("active")
            : "";
    }

    var leng = selection.parentElement.querySelectorAll(".product-section.active").length;

    if (leng < numberSelected) {
        selection.classList.add("active");
    }
    else {
        selection.classList.remove("active");
    }

    if (selection.classList.contains("active")) {
        if (selection.parentElement.querySelectorAll(".product-section.active").length == numberSelected) {
            selection.parentElement.parentElement.parentElement.nextElementSibling.scrollIntoView();
        }
    }

    var totalproduct = parseInt(document.querySelector("#totalbundle").value);
    var totalselected = parseInt(document.querySelectorAll(".product-section.active:not(.save-15)").length)

    // if (totalproduct == totalselected) {
    if (totalselected) {
        document.querySelector(".Step-product-button").removeAttribute("disabled");
    }
    else {
        document.querySelector(".Step-product-button").setAttribute("disabled", "disabled");
    }
}

function hideoptions() {
    document.querySelectorAll(".save-15.additional-item").forEach(function (save, index) {
        if (!save.classList.contains("active")) {
            if (document.querySelectorAll(".save-15.additional-item").length == 1) {

            }
            else {
                if (index > (document.querySelectorAll(".save-15.additional-item.active").length) && !save.classList.contains('removeit')) {
                    console.log(index)
                    save.classList.add("removeit");
                }
            }
        }
    });


    document.querySelectorAll(".save-15.active+.save-15").forEach(function (sav15) {
        if (sav15.classList.contains("removeit")) {
            sav15.classList.remove("removeit")
        }
    });

    if (document.querySelectorAll(".save-15.active").length == 0) {
        document.querySelectorAll(".save-15.additional-item").forEach(function (ad) {
            ad.classList.add("removeit")
        })
    }
}

function removeadditional(event, text) {
    event.preventDefault()
    var selection = event.currentTarget;
    var parentElement = selection.parentElement;
    if (parentElement.classList.contains("save-15") && parentElement.classList.contains("active")) {
        parentElement.classList.remove("active");
        parentElement.querySelector("img").setAttribute("src", "//gel-nail-wrap.nl/cdn/shop/t/6/assets/add-15.png?v=101526582812641706761693122363");
        parentElement.querySelector("p").textContent = text;
        setTimeout(() => {
            noselectedclose();
            hideoptions()
        }, 100);
    }
    else if (!parentElement.classList.contains("save-15") && parentElement.classList.contains("no-selected") && parentElement.classList.contains("active")) {
        parentElement.classList.remove("active");
        parentElement.querySelector("img").setAttribute("src", "//gel-nail-wrap.nl/cdn/shop/t/6/assets/nails.png?v=34725218854007842581693469768");
        parentElement.querySelector("p").textContent = text;
        setTimeout(() => {
            noselectedclose();
            hideoptions()
        }, 100);
    }
}

document.querySelectorAll(".product-section").forEach(function (prod) {
    prod.addEventListener("click", function (e) {
        selectionprocess(e);
    });
});

function openbundle() {
    document.querySelector(".bundle-section").classList.add("open");
    document.querySelector(".bundle-overlay").classList.add("open");
}

function closebundle() {
    document.querySelector(".bundle-section").classList.remove("open");
    document.querySelector(".bundle-overlay").classList.remove("open");
    noselectedclose()
}

document.querySelector(".bundle-close").addEventListener("click", function () {
    closebundle();
});

document.querySelector(".bundle-overlay").addEventListener("click", function () {
    closebundle();
});

document.querySelector(".Step-product-button").addEventListener("click", function () {
    this.setAttribute("disabled", "disabled");
    this.textContent = "Producten toevoegen...";
    items = [];

    var selectedids = document.querySelectorAll(".product-section.active");
    var loop = 1;
    var properties = {};
    var _bundle_id = crypto.randomUUID();
    for (let i = 0; i < selectedids.length; i++) {
        const selectedid = parseInt(selectedids[i].getAttribute("data-id"));
        if (!selectedids[i].classList.contains("notadd") && !selectedids[i].classList.contains("notaddoptional")) {
            items.push({
                quantity: 1,
                id: selectedid,
                properties: {
                    '_type': '15',
                    '_bundle_id': _bundle_id
                }
            })
        }
        else if (selectedids[i].classList.contains("notaddoptional")) {
            var discount = selectedids[i].getAttribute("data-discount");
            items.push({
                quantity: 1,
                id: selectedid,
                properties: {
                    '_type': discount,
                    '_bundle_id': _bundle_id
                }
            })
        }
        else {
            properties[loop] = selectedids[i].getAttribute("data-title")
            loop++;
            items.push({
                quantity: 1,
                id: selectedid,
                properties: {
                    '_type': 'Free',
                    '_bundle_id': _bundle_id
                }
            })
        }
    }

    properties['_bundle_id'] = _bundle_id;


    if (this.previousElementSibling.value) {
        items.push({
            quantity: 1,
            id: this.previousElementSibling.value,
            properties: properties
        })
    }

    console.log(items)

    jQuery.post('/cart/add.js', {
        items: items.reverse()
    });

    setTimeout(() => {
        window.location.href = "/cart"
    }, 2000);
});

// if (document.querySelector(".save-15.active svg")) {
//     document.querySelector(".save-15.active svg").addEventListener("click", function(e){
//         e.preventDefault();
//         var parentElement = this.parentElement;
//         parentElement.classList.remove("active");
//         parentElement.querySelector("img").setAttribute("src", "//gel-nail-wrap.nl/cdn/shop/t/6/assets/add-15.png?v=101526582812641706761693122363");
//         parentElement.querySelector("p").textContent = 'Bespaar 15%';
//     })   
// }

function disablebutton(customnextbtn, nextbtn, customprevbtn, prevbtn) {
    if (nextbtn.getAttribute("disabled") == "disabled") {
        customnextbtn.classList.add("hide");
    } else {
        customnextbtn.classList.remove("hide");
    }

    if (prevbtn.getAttribute("disabled") == "disabled") {
        customprevbtn.classList.add("hide");
    } else {
        customprevbtn.classList.remove("hide");
    }
}


function gonextslider(button) {
    button.parentElement.querySelector(".slider-button--next").click();
    setTimeout(() => {
        disablebutton(button.parentElement.querySelector(".custom-slider-next"),
            button.parentElement.querySelector(".slider-button--next"),
            button.parentElement.querySelector(".custom-slider-prev"),
            button.parentElement.querySelector(".slider-button--prev"));
    }, 500);
}

function goprevslider(button) {
    button.parentElement.querySelector(".slider-button--prev").click();
    setTimeout(() => {
        disablebutton(button.parentElement.querySelector(".custom-slider-next"),
            button.parentElement.querySelector(".slider-button--next"),
            button.parentElement.querySelector(".custom-slider-prev"),
            button.parentElement.querySelector(".slider-button--prev"));
    }, 500);
}

var instafeed = setInterval(() => {
    if (document.querySelector('#insta-feed h2') != null) {
        document.querySelector('#insta-feed h2').innerHTML = document.querySelector('#insta-feed h2').innerHTML + "</br><span>Deel je ervaring met de hashtag #gelnailwrappers</span>";
        $("#insta-feed .instafeed-new-layout-container").append("<div class='insta-btn-div'><a href='https://instagram.com/gel_nail_wrap' target='_blank' class='insta-btn'>NAAR INSTAGRAM</a></div>")
        clearInterval(instafeed)
    }
}, 100);
